import { AppName } from './common'
import {
    PerthNowSections,
    SevenNewsSections,
    TheWestSections,
    TheNightlySections,
} from './sections'

export type Section =
    | keyof PerthNowSections
    | keyof TheWestSections
    | keyof SevenNewsSections
    | keyof TheNightlySections

export function isValidSection(
    appName: 'perthnow',
    section: string,
): section is keyof PerthNowSections
export function isValidSection(
    appName: 'thewest',
    section: string,
): section is keyof TheWestSections
export function isValidSection(
    appName: 'sevennews',
    section: string,
): section is keyof SevenNewsSections
export function isValidSection(
    appName: 'thenightly',
    section: string,
): section is keyof TheNightlySections
export function isValidSection(
    appName: 'neutral',
    section: string,
): section is string
export function isValidSection(
    appName: AppName,
    section: string,
): section is Section
export function isValidSection(appName: AppName, section: string) {
    switch (appName) {
        case 'perthnow':
            return section in PerthNowSections
        case 'sevennews':
            return section in SevenNewsSections
        case 'thewest':
            return section in TheWestSections
        case 'thenightly':
            return section in TheNightlySections
    }
    return false
}

export const isWestRegionalSection = (section: string) => {
    if (section !== 'default' && section !== 'genwest') {
        return true
    }

    return false
}
